<div class="emds delete-modal-container">
    <div class="modal-default modal-flex" id="delete-modal">
        <div class="modal-header">
            <h5 class="modal-title">
                Delete {{getContextLabel()}}
            </h5>
        </div>
        <div class="modal-body remove-padding">
           <p>Are you sure that you want to delete <b> {{ title }} </b> from {{getContextLabel()}}?</p>
        </div>
        <div class="modal-footer">
            <button id="delete-modal-apply" class="btn-primary btn pull-right" (click)="onOk()">
                Yes
            </button>
            <button id="delete-modal-cancel" class="btn btn-secondary pull-right btn-flush-right" (click)="cancel()">
                Cancel
            </button>
        </div>
    </div>
</div>